<template>
  <section data-cy="perf-eval-pump-row">
    <EquipmentRow data-cy="equipment-row">
      <EquipmentPanel disable-toggle class="flex-grow-1">
        <template #header>{{ panelHeader }}</template>
        <template v-if="pumpLabel" #trigger>
          {{ pumpLabel }}
        </template>
      </EquipmentPanel>
    </EquipmentRow>

    <div class="grid">
      <div class="col">
        <ConverterInput
          data-cy="rate-correction-input"
          label="Viscosity Rate Correction"
          :model-value="perfevalXrefPump?.rate_correction_ratio"
          :base-unit="PercentageUnits.Ratio"
          :target-unit="PercentageUnits.Percentage"
          :model="PercentageUnits.options()"
          :update-unit="false"
          mode="write"
          @update:model-value="
            perfEvalPumpsForm.update({
              [perfevalXrefPump.id]: {
                ...perfevalXrefPump,
                rate_correction_ratio: $event
              }
            })
          "
        />
      </div>
      <div class="col">
        <ConverterInput
          data-cy="head-correction-input"
          label="Viscosity Head Correction"
          :model-value="perfevalXrefPump?.head_correction_ratio"
          :base-unit="PercentageUnits.Ratio"
          :target-unit="PercentageUnits.Percentage"
          :model="PercentageUnits.options()"
          :update-unit="false"
          mode="write"
          @update:model-value="
            perfEvalPumpsForm.update({
              [perfevalXrefPump.id]: {
                ...perfevalXrefPump,
                head_correction_ratio: $event
              }
            })
          "
        />
      </div>
      <div class="col">
        <ConverterInput
          data-cy="bhp-correction-input"
          label="Viscosity BHP Correction"
          :model-value="perfevalXrefPump?.brake_horsepower_correction_ratio"
          :base-unit="PercentageUnits.Ratio"
          :target-unit="PercentageUnits.Percentage"
          :model="PercentageUnits.options()"
          :update-unit="false"
          mode="write"
          @update:model-value="
            perfEvalPumpsForm.update({
              [perfevalXrefPump.id]: {
                ...perfevalXrefPump,
                brake_horsepower_correction_ratio: $event
              }
            })
          "
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { PropType } from "vue";
import type {
  PerfEvalXrefPumps,
  XrefPumps
} from "@/composables/forms/formTypes";

import { computed } from "vue";
import { injectStrict } from "@/utils/utils";
import { computePumpLabel } from "@/models/equipment/pumps/properties";
import EquipmentRow from "@/components/scenarios/EquipmentRow.vue";
import EquipmentPanel from "@/components/scenarios/EquipmentPanel.vue";
import ConverterInput from "@/components/ConverterInput.vue";
import { PercentageUnits } from "@/libs/units/percentage";
import { perfevalPumpsFormKey } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";

const props = defineProps({
  perfevalXrefPump: {
    type: Object as PropType<PerfEvalXrefPumps[number]>,
    default: null
  },
  equipmentXrefPump: {
    type: Object as PropType<XrefPumps[number]>,
    default: null
  },
  panelHeader: {
    type: String,
    default: "Pump Type"
  }
});

const perfEvalPumpsForm = injectStrict(perfevalPumpsFormKey);

const pumpLabel = computed(() =>
  computePumpLabel(
    props.equipmentXrefPump?.r_pump,
    props.equipmentXrefPump?.use_high_strength_shaft
  )
);
</script>
